import { useSlate } from 'slate-react'

import { Dropdown } from 'core-components/library/dropdown'

import { IBaseDropDown, IPropsForRender } from '../../interface/IToolbarProps'

export function DropDownForToolbar<T>(props: IPropsForRender<T> & IBaseDropDown<T>) {
  const editor = useSlate()

  return (
    <Dropdown
      classes={{ controlClasses: { root: props.className } }}
      source={props.source}
      caption={'value'}
      label={props.label}
      onChange={(value) => props.onToggle(editor, value as T, props.format === value)}
      value={props.format}
      disabled={props.disabled}
      renderFunction={(item) => {
        const formatDetail = props.formats.find((el) => el.style === item.key)
        if (formatDetail && formatDetail.icon) {
          return <i className={formatDetail.icon} />
        }
        return <div>{item.value}</div>
      }}
    />
  )
}
